import React from 'react';
import { useAbdm } from '..//context/AbdmContext';

export const OrgInfo: React.FC = () => {
    const { state, dispatch } = useAbdm();
    const { authData } = state;

    const handleNewFlow = () => {
        dispatch({ type: 'SET_AUTH_DATA', payload: null });
        localStorage.removeItem('abdm_auth_data');
        dispatch({ type: 'RESET_FLOW', payload: { currentStep: 'login' } });
    };

    if (!authData) return null;

    return (
        <div className="org-info">
            <div className="org-details">
                <span className="org-type">{authData.organizationType}</span>
                <strong>{authData.organizationName}</strong>
            </div>
            <div className="org-actions">
                <button onClick={handleNewFlow} className="btn-logout">Logout</button>
            </div>
        </div>
    );
};